import React from 'react'
import styled, {useTheme} from 'styled-components'
import {Box, Button} from '@miro-site/core'
import type {Question} from '../../types/Question'
import Description from './Description'
import Header from './Header'
import Title from './Title'

interface Props {
  question: Question
  onNext: (question: Question, answer?: string) => void
  onBack: () => void
  isBackVisible: boolean
  numberOfAllQuestions: number
  numberOfCurrentQuestion: number
  labels: Record<string, string>
  activeAnswer?: string
}

const ButtonOverride = styled(Button)`
  &:active {
    position: relative;
    top: 3px;
    ${({theme}) => theme.normalizeStyles(theme.buttons.variants.primary)}
  }
`

const Questionnaire: React.FC<Props> = ({
  question,
  onBack,
  onNext,
  isBackVisible,
  numberOfAllQuestions,
  numberOfCurrentQuestion,
  labels,
  activeAnswer,
}) => {
  const theme = useTheme()

  const onAnswer = (question: Question, selectedAnswer) => {
    onNext(question, selectedAnswer)
  }

  return (
    <>
      <Header
        onBack={isBackVisible && onBack}
        onSkip={() => onNext(question, null)}
        numberOfAllQuestions={numberOfAllQuestions}
        numberOfCurrentQuestion={numberOfCurrentQuestion}
        labels={labels}
      ></Header>
      <Box $mt={theme.spaces.xl}>
        <Title>{question.title}</Title>
        {question.description && <Description>{question.description}</Description>}
        <Box $mt={theme.spaces.lg}>
          {question.options.map(item => {
            return (
              <ButtonOverride
                key={item.key}
                $buttonType={activeAnswer == item.key ? 'primary' : 'secondary'}
                $size="small"
                $styles={{display: 'block', marginBottom: theme.spaces.sm, width: '100%'}}
                onClick={() => {
                  setTimeout(() => {
                    onAnswer(question, item.key)
                  }, 100)
                }}
              >
                {item.value}
              </ButtonOverride>
            )
          })}
        </Box>
      </Box>
    </>
  )
}

export default Questionnaire
